import Profile from './Profile/Profile';
import Nav from './Nav/Nav';
import MobileNav from './Nav/MobileNav';
import MobileNavButton from './Nav/MobileNavButton';
import SocialMediaList from './SocialMedia/SocialMediaList';
import MainContent from './MainContent/MainContent';
import './Home.css';
import React from 'react';

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobileNavOpen: false,
    }

    this.updateMobileNavStatus = this.updateMobileNavStatus.bind(this)
    this.handleScroll = this.handleScroll.bind(this);
  }

  updateMobileNavStatus() {
    this.setState({ isMobileNavOpen: !this.state.isMobileNavOpen })
  }



  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const aboutSection = document.getElementById('about');
    const experienceSection = document.getElementById('experience');
    const projectsSection = document.getElementById('projects');
    const scrollPosition = window.scrollY;

    const addClassToNav = (className) => {
      const navElements = ['nav-about', 'nav-experience', 'nav-projects'];
      navElements.forEach((navClass) => {
        const navElement = document.getElementsByClassName(navClass)[0];
        if (navClass === className) {
          navElement.classList.add('selected-nav-item');
        } else {
          navElement.classList.remove('selected-nav-item');
        }
      });
    };
    
    if (scrollPosition < experienceSection.offsetTop - 50) {
      addClassToNav('nav-about');
    } else if (scrollPosition < projectsSection.offsetTop - 50) {
      addClassToNav('nav-experience');
    } else {
      addClassToNav('nav-projects');
    }
  }

  render() {

    let mobileNavView;
    if(this.state.isMobileNavOpen) {
      mobileNavView = <MobileNav updateMobileNavStatus={ this.updateMobileNavStatus } />
    }else {
      mobileNavView = "";
    }

    return (
      <>
        <MobileNavButton updateMobileNavStatus={ this.updateMobileNavStatus } />
  
        <div className="main-profile-intro">
          <Profile />
          <Nav />
          <SocialMediaList />
        </div>
          
        <MainContent getMediaList={this.props.getMediaList}/>
        { mobileNavView }
      </>
    );
  }
}

export default Home;
